import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@kizen/kds/Icon';
import type { RestoreEvent } from './restoreEvents';
import { EventRow } from 'ts-components/PiChat/styles';

export const RestoreEventRow: FC<{ event: RestoreEvent; qaId: string }> = ({
  event,
  qaId,
}) => {
  const { t } = useTranslation();
  return (
    <EventRow $tone="info" data-qa-id={qaId}>
      <Icon
        icon={event.direction === 'undo' ? 'text-undo' : 'text-redo'}
        size="sm"
        color="font-secondary"
      />
      {t('Restored version {{version}}', { version: event.version })}
    </EventRow>
  );
};
